import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2598be1f&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "@/less/service.less?vue&type=style&index=0&id=2598be1f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2598be1f",
  null
  
)

export default component.exports